import moment from 'moment';

import { RiskChatHistoryGroup } from 'common/constants/AISimulationConstants';

import { IChatHistory, IGroupChatHistory } from '../api/type-def';

const { TODAY, YESTERDAY, PAST7DAYS, PAST30DAYS } = RiskChatHistoryGroup;

const getStructuredObjects = (item: IChatHistory) => {
	const itemDate = moment(
		item.updatedAt ? item.updatedAt : item.createdAt,
	).endOf('day');
	const today = moment().endOf('day');
	const differenceInDays = today.diff(itemDate, 'days');
	switch (true) {
		case differenceInDays === 0:
			return TODAY;
		case differenceInDays === 1:
			return YESTERDAY;
		case differenceInDays > 1 && differenceInDays <= 7:
			return PAST7DAYS;
		case differenceInDays > 7 && differenceInDays < 30:
			return PAST30DAYS;
		default:
			return `${itemDate.format('MMMM')}`;
	}
};
const months = [
	...Object.values(RiskChatHistoryGroup),
	'December',
	'November',
	'October',
	'September',
	'August',
	'July',
	'June',
	'May',
	'April',
	'March',
	'February',
	'January',
];

export const getGroupChatHistory = (chartHistory: IChatHistory[]) => {
	const groupedData: IChatHistory[] = chartHistory.map((ele: IChatHistory) => ({
		...ele,
		groupName: getStructuredObjects(ele),
	}));
	groupedData.sort((a: IChatHistory, b: IChatHistory) => {
		if (a.groupName && b.groupName) {
			return months.indexOf(a.groupName) - months.indexOf(b.groupName);
		}
		return 0;
	});
	const sortedArray = groupedData;

	const chartGroupArray: IGroupChatHistory[] = sortedArray.reduce(
		(accumulator, current) => {
			const existingEntityIndex = accumulator.findIndex(
				(item) => item.groupName === current.groupName,
			);
			if (existingEntityIndex !== -1) {
				accumulator[existingEntityIndex] = {
					groupName: accumulator[existingEntityIndex].groupName,
					data: [...accumulator[existingEntityIndex].data, current],
				} as IGroupChatHistory;
			} else {
				accumulator.push({
					groupName: current.groupName,
					data: [current],
				} as IGroupChatHistory);
			}
			return accumulator;
		},
		[] as IGroupChatHistory[],
	);
	return chartGroupArray;
};
